/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Dq_Already_ActiveInputs */



/**
* | output |
* | --- |
* | "This player already has an active disqualification in this tournament." |
*
* @param {Sanction_Dq_Already_ActiveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_dq_already_active = /** @type {((inputs?: Sanction_Dq_Already_ActiveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Dq_Already_ActiveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce joueur a déjà une disqualification active dans ce tournoi.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este jugador ya tiene una descalificación activa en este torneo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este jogador já tem uma desqualificação ativa neste torneio.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo giocatore ha già una squalifica attiva in questo torneo.")
	return /** @type {LocalizedString} */ ("This player already has an active disqualification in this tournament.")
});